export const LOCAL_STORAGE_KEY = "";
export const Role = {
    admin: "admin",
};

